import {axiosInstance} from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";
import i18next from "i18next";


export const listCategories = catchAsync(async () => {
  const { data } = await axiosInstance.get('categories', {
    headers: {
      "Accept-Language": i18next.language,
    }
  });
  return data;
});
